import 'idempotent-babel-polyfill';
import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';

import '@/index.css';
import '@/i18n';
import {RouterApp} from '@/routes';
import * as serviceWorker from '@/serviceWorker';

ReactDOM.render(
  React.createElement(RouterApp),
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
